(function () {
    'use strict';

    angular.module("imApp").factory("choicesService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 1212,
                    parameters: parms || {}
                });
            },
            listChoices: function (parms) {
                return $ihttp.post({
                    method: 1213,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
